import { create } from 'zustand'

import type { IncomeDocument, TripLineItem } from '@/types/income'

interface BoltStore {
  balanceAnalysis: IncomeDocument
  setBalanceAnalysis: (balanceAnalysis: IncomeDocument) => void

  tripAnalysis: TripLineItem[]
  setTripAnalysis: (tripAnalysis: TripLineItem[]) => void

  resetAnalysis: () => void
}

export const useBoltStore = create<BoltStore>((set) => ({
  balanceAnalysis: {} as IncomeDocument,
  setBalanceAnalysis: (balanceAnalysis: IncomeDocument) => set({ balanceAnalysis }),

  tripAnalysis: [] as TripLineItem[],
  setTripAnalysis: (tripAnalysis: TripLineItem[]) => set({ tripAnalysis }),

  resetAnalysis: () => set({
    balanceAnalysis: {} as IncomeDocument,
    tripAnalysis: [] as TripLineItem[]
  }),
}))